export default {
  viewPayments: (context, value) => {
    context.commit("viewPayments", value)
  },
  viewPlans: (context, value) => {
    context.commit("viewPlans", value)
  },
}
